export default __webpack_public_path__ + "assets/icon-all-accounts.f8244992.webp";